module.exports = __webpack_public_path__ + "fonts/15b4bbd.ttf";